import React from "react";
import PropTypes from "prop-types";

import { Container, Text } from "./styles";

const BestValue = ({ text = "Best Value", leftMargin }) => {
    return (
        <Container leftMargin={leftMargin}>
            <Text>{text}</Text>
        </Container>
    );
};

BestValue.propTypes = {
    text: PropTypes.string,
    leftMargin: PropTypes.bool
};

export default BestValue;
